class SubscriptionPermission
{
    // Admin privileges, other permissions are not checked
    static ROOT = 'subscription.*';

    // Enabled flag: if not present, access denied on any operation. Not required for root
    static _ENABLED = 'subscription._m';

    // Initiate subscription sync
    static SYNC = 'subscription.sync';

    // Can create new subscription
    static CREATE = 'subscription.create';

    // Allowed to provide subscription description on creation
    static CREATE_OPT_DESCRIPTION = 'subscription.create.opt.description';

    // Allowed to use coupon on creation
    static CREATE_OPT_COUPON = 'subscription.create.opt.coupon';

    // Allowed to provide custom trial end date
    static CREATE_OPT_TRIAL = 'subscription.create.opt.trial';

    // Allowed to override billing cycle anchor
    static CREATE_OPT_BILLING_CYCLE_ANCHOR = 'subscription.create.opt.billing_cycle_anchor';

    // Allowed to provide backdate start date on creation
    static CREATE_OPT_BACKDATE = 'subscription.create.opt.backdate';

    // Disable auto-renew soft-cancel
    static AUTO_RENEW_DISABLE = 'subscription.auto_renew.disable';

    // Enable auto-renew "do not cancel" operation
    static AUTO_RENEW_ENABLE = 'subscription.auto_renew.enable';

    // Apply pause to a subscription
    static PAUSE_APPLY = 'subscription.pause.apply';

    // Apply new pause settings to an already paused subscription
    static PAUSE_UPDATE = 'subscription.pause.update';

    // Release subscription pause
    static PAUSE_RELEASE = 'subscription.pause.release';

    // Use custom overrides when performing operations on pause schedule
    static PAUSE_CUSTOM = 'subscription.pause.custom';

    // Release current update schedule
    static SCHEDULE_RELEASE = 'subscription.schedule.release';

    // Update payment method
    static PAYMENT_METHOD_UPDATE = 'subscription.payment_method.update';

    // Use MANUAL anchor when performing subscription update operations
    static UPDATE_MANUAL_ANCHOR = 'subscription.update.manual_anchor';

    // Update price of a single subscription item
    static ITEM_UPDATE_SINGLE = 'subscription.item_update.single';

    // Apply new items to a subscription
    static ITEM_UPDATE_BATCH = 'subscription.item_update.batch';
}

export default SubscriptionPermission;
